/**
 * 登降園 コメント記述のモーダル
 * @param {*} $scope
 * @param {*} $modalInstance
 * @param {*} editItem
 */
function memberAttendanceModalCtrl($scope, $modalInstance, editItem) {
  $scope.name = editItem.name;
  $scope.id = editItem.id;
  $scope.content = editItem.content;
  $scope.memberID = editItem.memberID;
  $scope.title = angular.isDefined(editItem.title) ? editItem.title : null;
  $scope.attendanceDate = angular.isDefined(editItem.attendanceDate) ? editItem.attendanceDate : null;
  $scope.target = editItem.target;
  $scope.ok = function () {
    $modalInstance.close({
      name: $scope.name,
      id: $scope.id,
      content: $scope.content,
      memberID: $scope.memberID,
      attendanceDate: $scope.attendanceDate,
      target: $scope.target,
    });
  };
  $scope.cancel = function () {
    $modalInstance.dismiss();
  };
}

angular.module('inspinia').controller('memberAttendanceModalCtrl', memberAttendanceModalCtrl);
